import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import { googleClickCtaEvent } from '../../../../utils/analytics';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import { appendToUrlPath } from '../../../../utils/linkUtils';
import CTAButton, { ctaEnums } from '../../../@shared/ctaButton';
import CTAWithArrow from '../../../@shared/ctaWithArrow';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import Picture from '../../../@shared/picture';
import { TProductCard } from '../../types/seriesListing.types';
import SummarySpecs from './summarySpecs';
import { appendRootToRichTextInternalLinks } from '../../../../utils/appendRootToRichTextInternalLinks.utils';
import { appendRootToInternalLink } from '../../../../utils/appendRootToInternalLink.utils';

const ProductCard = (props: TProductCard): JSX.Element => {
  const {
    titleUrl,
    title,
    type,
    description,
    summarySpecs,
    button1,
    button2,
    assets,
    baseUrl,
    bodyTextVisibility,
    bodySpecVisibility,
    componentNumber,
  } = props;
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);
  return (
    <article className={`product-card__wrapper ${encodeURI(type || '')}`}>
      <RoutableNotEditableLink
        className="product-card"
        href={appendToUrlPath(baseUrl || '', titleUrl || '')}
        onClick={(): void => googleClickCtaEvent('Link', type, title, componentNumber)}
      >
        <div className="product-card__image-wrapper">
          <Picture
            productImageProps={{
              desktopRendition: assets?.[0]?.rendition_desktop_size500,
              mobileRendition: assets?.[0]?.rendition_mobile_size500,
              alt: assets?.[0]?.alt,
              imageClassName: 'product-card__image',
            }}
          />
        </div>
        <div className="product-card__content">
          {type ? <p className="product-card__eyebrow">{type}</p> : null}
          {title ? <h2 className="product-card__title">{title}</h2> : null}
          {bodyTextVisibility !== 'hide' && description && (
            <RichText
              field={{ value: appendRootToRichTextInternalLinks(description) }}
              editable={false}
              className="product-card__description rich-text"
            />
          )}
          {bodySpecVisibility !== 'hide' && summarySpecs?.length ? <SummarySpecs summarySpecs={summarySpecs} /> : null}
          <div className="product-card__button-wrapper">
            {button1?.url ? (
              <CTAButton type={ctaEnums.primaryRed}>
                <RoutableNotEditableLink
                  className="product-card__button"
                  href={appendRootToInternalLink(button1.url)}
                  target={targetLinkdsk({ value: { href: button1?.url, target: button1?.target } }, isDesktop)}
                  onClick={(event): void => {
                    event.stopPropagation();
                    googleClickCtaEvent('Button', button1?.label, title, componentNumber);
                  }}
                >
                  {button1?.label}
                </RoutableNotEditableLink>
              </CTAButton>
            ) : null}
            {button2?.url ? (
              <CTAWithArrow
                text={button2?.label || ''}
                href={appendRootToInternalLink(button2.url) || ''}
                target={targetLinkdsk({ value: { href: button2?.url, target: button2?.target } }, isDesktop)}
                onClick={(event): void => {
                  event.stopPropagation();
                  googleClickCtaEvent('Button', button2?.label, title, componentNumber);
                }}
              />
            ) : null}
          </div>
        </div>
      </RoutableNotEditableLink>
    </article>
  );
};

export default ProductCard;
